import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { BookSalesAnalyticsFilterRequest } from '../../requests/platform/book-sales-analytics-filter.request';
import { BookSalesAnalyticsFunnelResponse } from '../../responses/platform/book-sales-analytics-funnel.response';
import { BookSalesAnalyticsSalesByItemResponse } from '../../responses/platform/book-sales-analytics-sales-by-item.response';
import { BookSalesAnalyticsSalesByKitResponse } from '../../responses/platform/book-sales-analytics-sales-by-kit.response';
import { BookSalesAnalyticsSoldListResponse } from '../../responses/platform/book-sales-analytics-sold-list.response';
import { BookSalesAnalyticsSummaryResponse } from '../../responses/platform/book-sales-analytics-summary.response';
import { BookSalesAnalyticsTimeSeriesResponse } from '../../responses/platform/book-sales-analytics-time-series.response';
import { KitOptionResponse } from '../../responses/platform/kit-option.response';
import { PublishedBooksResponse } from '../../responses/platform/published-books.response';


@Injectable({
  providedIn: 'root'
})
export class BookSalesAnalyticsService extends CommonService {
  private baseUrl = environment.urlApiPlatform + 'BookSalesAnalytics/';

  constructor(private http: HttpClient) {
    super();
  }

  public summary(req: BookSalesAnalyticsFilterRequest): Observable<BookSalesAnalyticsSummaryResponse> {
    return this.http
      .post<BookSalesAnalyticsSummaryResponse>(this.baseUrl + 'summary', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public funnel(req: BookSalesAnalyticsFilterRequest): Observable<BookSalesAnalyticsFunnelResponse> {
    return this.http
      .post<BookSalesAnalyticsFunnelResponse>(this.baseUrl + 'funnel', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public timeSeries(req: BookSalesAnalyticsFilterRequest): Observable<BookSalesAnalyticsTimeSeriesResponse> {
    return this.http
      .post<BookSalesAnalyticsTimeSeriesResponse>(this.baseUrl + 'timeseries', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salesByKit(req: BookSalesAnalyticsFilterRequest): Observable<BookSalesAnalyticsSalesByKitResponse> {
    return this.http
      .post<BookSalesAnalyticsSalesByKitResponse>(this.baseUrl + 'sales-by-kit', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salesByItem(req: BookSalesAnalyticsFilterRequest): Observable<BookSalesAnalyticsSalesByItemResponse> {
    return this.http
      .post<BookSalesAnalyticsSalesByItemResponse>(this.baseUrl + 'sales-by-item', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public soldList(req: BookSalesAnalyticsFilterRequest): Observable<BookSalesAnalyticsSoldListResponse> {
    return this.http
      .post<BookSalesAnalyticsSoldListResponse>(this.baseUrl + 'sold-list', req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
  public getKits(idBookVersion: number): Observable<KitOptionResponse> {
    return this.http
      .get<KitOptionResponse>(this.baseUrl + `kits/idBookVersion/${idBookVersion}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
    public getPublishedBooks(): Observable<PublishedBooksResponse> {
    return this.http
      .get<PublishedBooksResponse>(this.baseUrl + 'published-books', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
